import React, { createContext, useState } from "react";

export const SearchReportContext = createContext({});

const SearchReportProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState({
    username: "",
    fullName: "",
    estateId: "",
    lineOfWorkId: "",
  });
  const [pageValues, setPageValues] = useState({
    page: 0,
    pageSize: 10,
    total: 0,
    totalPage: 0,
    sortBy: "userId",
    sortDirection: "ASC",
  });

  return (
    <SearchReportContext.Provider
      value={{ searchValues, setSearchValues, pageValues, setPageValues }}
    >
      {children}
    </SearchReportContext.Provider>
  );
};

export default SearchReportProvider;
